
import { Configuration } from '../src/Configuration';
import { PropType } from 'vue/dist/vue';
import {AuthAppService} from '../src/AuthAppService';

export default {
    props: {
        service: {
            type: Object as PropType<AuthAppService>,
        }
    },
    methods: {
        makeService(service: string): string {
            return this.service.makeAuthLinkByService(service);
        }
    },
    data() {
        return {
            isEsia: this.service.configuration.isEsia,
            isSocials: this.service.configuration.isSocials,
            services: this.service.configuration.oauth2Service,
        };
    },
};
